import React from 'react';
import { Provider } from 'react-redux';
import { store, history } from './redux/store';
import PublicRoutes from './router';
import { ThemeProvider } from 'styled-components';
import { LocaleProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import themes from './config/themes';
import AppLocale from './languageProvider';
import { themeConfig } from './config';
import DashAppHolder from './dashAppStyle';
import Boot from './redux/boot';

const App = () => (
  <LocaleProvider>
    <IntlProvider>
      <ThemeProvider theme={themes[themeConfig.theme]}>
        <DashAppHolder>
          <Provider store={store}>
            <PublicRoutes history={history} />
          </Provider>
        </DashAppHolder>
      </ThemeProvider>
    </IntlProvider>
  </LocaleProvider>
);
Boot()
  .then(() => App())
  .catch(error => console.error(error));

export default App;
export { AppLocale };


// WEBPACK FOOTER //
// ./src/App.js